import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { SitesDetailsQueryParams, SitesDetailsResponse } from './types';
import {
  zodSitesDetailsQueryParamsSchema,
  zodSitesDetailsResponseSchema,
} from './validations';

/**
 * Fetches the data for sites details from the API with the given query parameters.
 *
 * @param queryParams - The query parameters for fetching the sites details.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The sites details data including paginated table items.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Site/operation/get_site_activity_table_site_statistics_details_post
 */
export const fetchSitesDetails = async (
  queryParams: SitesDetailsQueryParams,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.ANALYTICS.GET_SITES_DETAILS(), {
      json: queryParams,
      validate: {
        body: zodSitesDetailsQueryParamsSchema,
      },
      ...options,
    })
    .json<SitesDetailsResponse>();

  // Validate the response
  const validatedResponse = zodSitesDetailsResponseSchema.parse(response);

  return validatedResponse;
};
